import { useCallback, useMemo } from 'react'

import { ReduxService } from 'dashboard-services/services'

import groupConfigService from '../groupConfigService'

export default (() => {
  const useGroupConfigHandlers = ({ setGroupConfig }) => {
    const onChangeGroupConfig = useCallback((value, { name }) => setGroupConfig(config => ReduxService.updateObject(config, { [name]: value })), [setGroupConfig]),
          onChangeSymbolsConfigSwitch = useCallback((value, { name }) => setGroupConfig(config =>
            ReduxService.updateObject(
              config, {
                symbolsConfig: ReduxService.updateObject(
                  config.symbolsConfig,
                  { [name]: !value }
                )
              }))
          , [setGroupConfig]),
          onChangeFileConfig = useCallback((value, { name, index }) =>
            setGroupConfig(config =>
              ReduxService.updateObject(
                config, {
                  filesConfigs: config.filesConfigs.updateInList({ [name]: value }, index)
                })
            )
          , [setGroupConfig]),
          onChangeFileTypes = useCallback(fileTypes =>
            setGroupConfig(config =>
              ReduxService.updateObject(
                config, {
                  filesConfigs: groupConfigService.setSelectedFileTypes({ filesConfigs: config.filesConfigs, fileTypes })
                })
            )
          , [setGroupConfig])

    return useMemo(() => ({
      onChangeGroupConfig,
      onChangeSymbolsConfigSwitch,
      onChangeFileConfig,
      onChangeFileTypes
    }), [onChangeFileConfig, onChangeFileTypes, onChangeGroupConfig, onChangeSymbolsConfigSwitch])
  }

  return {
    useGroupConfigHandlers
  }
})()
